var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isProd)?_c('button',{attrs:{"disabled":_vm.disabled},on:{"click":_vm.show}},[_vm._v("Get MTX Tokens")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }